import { withStyles } from '@material-ui/core';
import { compose } from 'redux';
import withBrowserHistory from 'modules/shell/hoc/withBrowserHistory';
import { withRouter } from 'react-router-dom';
import styles from './PinBox.styles';
import PinBox from './PinBox';

export default compose(withStyles(styles), withBrowserHistory(), withRouter)(PinBox);
